import { render, staticRenderFns } from "./AnnouncementsROAs.vue?vue&type=template&id=54f15270&scoped=true&"
import script from "./AnnouncementsROAs.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsROAs.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsROAs.vue?vue&type=style&index=0&id=54f15270&lang=scss&scoped=true&"
import style1 from "./AnnouncementsROAs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f15270",
  null
  
)

export default component.exports